var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolRaftCrewFieldObs = function SvgFiremapSymbolRaftCrewFieldObs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#firemap-symbol-raft-crew-field-obs_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0 2c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    fillRule: "evenodd",
    d: "M5.013 13.158v1.22H4V10h1.895c.387 0 .724.065 1.01.194a1.5 1.5 0 0 1 .66.55c.154.238.23.52.23.844 0 .326-.078.606-.234.841a1.485 1.485 0 0 1-.666.541l.92 1.32-.039.087H6.79l-.844-1.22zm2.802 1.131L9.727 10h1l1.958 4.377h-1.063l-.388-.938H9.202l-.388.938h-.937zm-2.802-1.938h.825c.305 0 .536-.067.694-.2.159-.133.238-.32.238-.563 0-.246-.08-.434-.238-.566-.158-.13-.39-.197-.694-.197h-.825zm5.208-1.357-.694 1.676h1.388zm3.689 3.383v-1.594h2.026v-.813H13.91v-1.157h2.276v.012h1.4v3.552H18.6v-3.552H20V10h-3.794v.813h-.02V10h-3.288v4.377z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "firemap-symbol-raft-crew-field-obs_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgFiremapSymbolRaftCrewFieldObs;